import { useNavigate } from "react-router-dom";
import { useImpersonation } from "@/contexts/ImpersonationContext";

export default function ImpersonationBanner() {
  const { impersonating, impersonatedRole, impersonatedRetailer, stopImpersonation } =
    useImpersonation();
  const navigate = useNavigate();

  if (!impersonating) return null;

  const label = impersonatedRetailer?.store_name ?? "Unknown Retailer";
  const role = impersonatedRole ?? "retailer";

  const handleExit = () => {
    stopImpersonation();
    navigate("/admin", { replace: true });
  };

  return (
    <div
      style={{ height: 40, zIndex: 99999 }}
      className="fixed top-0 left-0 w-full bg-orange-500 flex items-center justify-between px-4 shrink-0"
    >
      <p className="text-white text-sm font-medium truncate">
        👁 Viewing as <span className="font-semibold">{label}</span>{" "}
        <span className="opacity-75">({role})</span>
        <span className="ml-2 opacity-75">— Read-only mode</span>
      </p>
      <button
        onClick={handleExit}
        className="ml-4 shrink-0 rounded border border-white/40 bg-white/20 px-3 py-1 text-xs font-semibold text-white hover:bg-white/30 transition"
      >
        Exit Impersonation
      </button>
    </div>
  );
}
